import { render, staticRenderFns } from "./FootBar.vue?vue&type=template&id=5dcbce0f&scoped=true"
import script from "./FootBar.vue?vue&type=script&lang=js"
export * from "./FootBar.vue?vue&type=script&lang=js"
import style0 from "./FootBar.vue?vue&type=style&index=0&id=5dcbce0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcbce0f",
  null
  
)

export default component.exports